import { Typography } from '@mui/material';
import * as React from 'react';

export const LocationsPage: React.FunctionComponent = () => {
    return <Typography>Locations page: Work in progress</Typography>;
};
